import React, { useEffect, useState } from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';
import HomeActivo from 'components/NoMatriculados/HomeActivo';
import HomeMatriculacion from 'components/NoMatriculados/HomeMatriculacion';
import HomeRematriculacion from 'components/NoMatriculados/HomeRematriculacion';
import { getNoMatriculate } from '../../features/nomatriculates/nomatriculatesAPI';
import { getSolicitudMatricula } from '../../features/matriculas/matriculasAPI';
import { getSolicitudRematriculacion } from '../../features/rematriculacion/rematriculacionAPI';
import { NoMatriculado } from 'types/NoMatriculados';
import { MatriculaRequest } from 'types/Matriculas';
import { RematriculacionRequest } from 'types/Rematriculacion';

export default function Home() {
  const [isLoading, setLoading] = useState(true);

  const [noMatriculado, setNoMatriculado] = useState<Partial<NoMatriculado | null>>(null);
  const [contexto, setContexto] = useState<string>('');

  const [matriculacion, setMatriculacion] = useState<Partial<MatriculaRequest>>({
    state_id: 0,
  });
  const [rematriculacion, setRematriculacion] = useState<Partial<RematriculacionRequest>>({
    state_id: 0,
  });

  useEffect(() => {
    setLoading(true);

    const loadData = async () => {
      try {
        const noMatriculateResponse = await getNoMatriculate();
        if (noMatriculateResponse) {
          setNoMatriculado(noMatriculateResponse);
        }
      } catch (err) {
        alert(
          'Se produjo un error al intentar recuperar información inicial. ' +
            'Por favor, intente nuevamente más tarde.',
        );
        console.error('Home', 'Error al cargar datos iniciales');
        console.info(err);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  useEffect(() => {
    if (!!noMatriculado) {
      if (
        (!!noMatriculado.kinesiologo && !!noMatriculado.matriculate) &&
        noMatriculado.matriculate.MTR001_ESTADO === 0 &&
        [1, 2, 4].includes(noMatriculado.matriculate.MTR001_C_MOTIVO_BAJA)
      ) {
        // Existe el Kinesiologo y Matriculado en Matriculas, y está inactivo
        setContexto('rematriculacion');
      } else if (
        (!!noMatriculado.kinesiologo && !!noMatriculado.matriculate) &&
        noMatriculado.matriculate.MTR001_ESTADO === 1
      ) {
        // Existe el Kinesiologo y Matriculado en Matriculas, y está activo
        setContexto('activo');
      } else {
        // Se encuentra en proceso de matriculación
        setContexto('matriculacion');
      }
    }
  }, [noMatriculado]);

  useEffect(() => {
    const loadSolicitudMatricula = async () => {
      setLoading(true);
      try {
        const solicitudMatriculaResponse = await getSolicitudMatricula();
        if (solicitudMatriculaResponse) {
          setMatriculacion(solicitudMatriculaResponse);
        }
      } catch (err) {
        alert(
          'Se produjo un error al intentar recuperar información inicial. ' +
            'Por favor, intente nuevamente más tarde.',
        );
        console.error('Home', 'Error al cargar datos iniciales');
        console.info(err);
      } finally {
        setLoading(false);
      }
    };

    const loadSolicitudRematriculacion = async () => {
      setLoading(true);
      try {
        const solicitudRematriculacionResponse = await getSolicitudRematriculacion();
        if (solicitudRematriculacionResponse) {
          setRematriculacion(solicitudRematriculacionResponse);
        }
      } catch (err) {
        alert(
          'Se produjo un error al intentar recuperar información inicial. ' +
            'Por favor, intente nuevamente más tarde.',
        );
        console.error('Home', 'Error al cargar datos iniciales');
        console.info(err);
      } finally {
        setLoading(false);
      }
    };

    if (contexto == 'matriculacion') {
      loadSolicitudMatricula();
    } else if (contexto == 'rematriculacion') {
      loadSolicitudRematriculacion();
    }
  }, [contexto]);

  return (
    <div className="content">
      <Row>
        <Col md={12}>
          <Card>
            <CardBody>
              { contexto === 'matriculacion'
                ?
                  <HomeMatriculacion
                    isLoading={isLoading}
                    matriculacion={matriculacion}
                  />
                : contexto === 'rematriculacion'
                  ?
                    <HomeRematriculacion
                      isLoading={isLoading}
                      rematriculacion={rematriculacion}
                    />
                  : contexto === 'activo'
                    ?
                      <HomeActivo
                        noMatriculado={noMatriculado ?? {}}
                      />
                    :
                      <>
                        Hubo un problema al cargar su información. Por favor, intente nuevamente más tarde.
                      </>
              }
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
